import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {ProjectUserInfoData} from '@/services/ProjectAuthApi/types';
import {StatefulStore} from '@/stores/StatefulStore';

type UserState = Omit<
  ProjectUserInfoData,
  'energyValue' | 'nextEnergyIn' | 'bonuses' | 'userItems' | 'items' | 'isOpenedAllItems'
>;

export class UserStore extends StatefulStore<UserState, HttpError | FrontendError> {
  public setUserState(userInfo: UserState): void {
    this.toSuccess(userInfo);
  }

  public getErrorData = (): HttpError | FrontendError => {
    return this.getStoreError();
  };

  public getUserIsJunior(): boolean {
    try {
      return this.getDataOrFail().isJunior;
    } catch (e) {
      return false;
    }
  }

  public getUserIsSubscribedToNotifications(): boolean {
    try {
      return this.getDataOrFail().isSubscribedToNotifications;
    } catch (e) {
      return false;
    }
  }

  public setIsSubscribedToNotificationsSuccess = (isSubscribedToNotifications: boolean): void => {
    const state = this.getDataOrFail();

    this.toSuccess({
      ...state,
      isSubscribedToNotifications,
    });
  };

  public getUserIsOnboardingFinished(): boolean {
    try {
      return this.getDataOrFail().isOnboardingFinished;
    } catch (e) {
      return false;
    }
  }

  public setOnboardingFinishedSuccess = (): void => {
    const state = this.getDataOrFail();

    this.toSuccess({
      ...state,
      isOnboardingFinished: true,
    });
  };

  public updateUserStateData = (partialState: Partial<ProjectUserInfoData>): void => {
    const newState = {
      ...this.getDataOrFail(),
      ...partialState,
    };
    this.toSuccess(newState);
  };
}

injected(UserStore);
